module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-cost-center/master-cost-center.component.scss
// module id = ./src/app/master/master-cost-center/master-cost-center.component.scss
// module chunks = main